import { Component, ComponentData } from './components/'
import { AssetLoader } from './assets/'
import { Queue } from '../utils/'
import { DrupalProvider } from '../providers/'
import { EVENTS } from '../config/'

export async function load(useCache: boolean) {
    
    const urlParams = new URLSearchParams(window.location.search)
    const debug = (urlParams.get('debug-loader') == 'loader')

    if (debug){
        console.log("======================================");
        console.log("== Container Loader Drupal - version : 1.0.2");
        console.log("======================================");    
    }

    const containers = DrupalProvider.getContainers(debug)

    const componentQueue = new Queue<{
        container: HTMLElement
        componentData: ComponentData
    }>()

    for (const container of containers) {
        const url = DrupalProvider.getDataUrl(container, debug)
        if (!url) {
            console.error('Missing DrupalProvider.getDataUrl attribute on container element')
            continue
        }
        const shieldAuthorization = DrupalProvider.getDataShieldAuthorization(container, debug)
        const data = await DrupalProvider.fetchApi(url, shieldAuthorization, useCache, debug)
        await AssetLoader.loadAssets('css',data.assets.css, useCache, debug)
        await AssetLoader.loadAssets('js',data.assets.js, useCache, debug)

        // Add components to the queue
        for (const componentData of data.field_components) {
            componentQueue.enqueue({ container, componentData })
        }
    }

    // Load components from the queue in order
    await loadComponentsFromQueue(componentQueue, debug)

    // Emit custom events on the window object
    const projectsLoadedEvent = new CustomEvent(EVENTS.WEB_COMPONENT_PROJECTS_LOADED)
    window.dispatchEvent(projectsLoadedEvent)
}

async function loadComponentsFromQueue(
    componentQueue: Queue<{
        container: HTMLElement
        componentData: ComponentData
    }>
    , debug: boolean
) {
    if (!componentQueue.isEmpty()) {
        const { container, componentData } = componentQueue.dequeue()!
        await loadComponent(container, componentData, debug)
        await loadComponentsFromQueue(componentQueue, debug)
    }
}

export async function loadComponent(container: HTMLElement, componentData: ComponentData, debug: boolean) {
    if (debug) {
        console.log(`Add component ${componentData.uuid}`)
    }
    const component = new Component(componentData)
    container.appendChild(component.getElement())

    // Emit custom event on the window object if this is the first component
    if (container.children.length === 1) {
        const firstComponentDisplayedEvent = new CustomEvent(
            EVENTS.WEB_COMPONENT_FIRST_COMPONENT_DISPLAYED
        )
        window.dispatchEvent(firstComponentDisplayedEvent)
    }

    // Emit custom event on the window object if this is the component with the anchor
    const anchor = window.location.hash.substring(1)
    if (componentData.sectionId === anchor) {
        // Scroll to the element with the anchor
        component.getElement().scrollIntoView({ behavior: 'smooth' })

        const anchorLoadedEvent = new CustomEvent(EVENTS.WEB_COMPONENT_ANCHOR_LOADED, {
            detail: { uuid: componentData.uuid }
        })
        window.dispatchEvent(anchorLoadedEvent)
    }
}
